import { createElement } from 'react';
import { usePerfTier } from '../../hooks/usePerfTier';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';

/**
 * SMIL `<animate>` that removes itself under reduced motion or on low-tier
 * devices. Rendering `null` is what actually stops the animation — SMIL has
 * no "paused" attribute that survives a re-render.
 */
export function SvgAnimate(props: React.SVGProps<SVGAnimateElement>) {
  const reduced = usePrefersReducedMotion();
  const tier = usePerfTier();
  if (reduced || tier === 'low') return null;
  return createElement('animate', props);
}

/** SMIL `<animateMotion>` with the same reduced-motion / low-tier gating. */
export function SvgAnimateMotion(props: React.SVGProps<SVGAnimateMotionElement>) {
  const reduced = usePrefersReducedMotion();
  const tier = usePerfTier();
  if (reduced || tier === 'low') return null;
  return createElement('animateMotion', props);
}
